export default (percentage: number) => {
  return 1 * Math.sin((percentage / 1) * (Math.PI / 2));
};
